require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-schoolgarden.json") })
        }
      }, "path---projecten-schoolgarden");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-schoolgarden!./.cache/json/projecten-schoolgarden.json
// module id = 441
// module chunks = 231608221292675